import { UseCasePage } from "../components/UseCasePage";
import { legalDepositionMeetingCopilotCopy } from "../lib/translations/pages/use-case-legal-deposition-meeting-copilot";

export function LegalDepositionMeetingCopilot() {
  return (
    <UseCasePage
      content={legalDepositionMeetingCopilotCopy}
      path="/use-cases/legal-deposition-meeting-copilot"
    />
  );
}
